import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useSelector } from "react-redux";
import PreviewRibbonImage from "../../../../assets/images/preview-ribbon.png";
import "./Step3Card.css";

const Step3Card = ({ showCircularBar, showPreviewRibbon, data, pageName, children }) => {
  const selectedPage = useSelector((state) => state.fb.selectedFbPage);
  const user = useSelector((state) => state.user.user);

  const name = pageName ?? selectedPage?.name ?? user?.business_name ?? "Facebook Page";

  return (
    <>
      {data && (
        <div className="step3Card" key={data.id}>
          <div className="step3Header">
            <div>
              <img className="step3UserImage" src={data?.logo} alt="userImage" />
              <div className="step3UserInfo">
                <p className="step3Heading">{name}</p>
                <p className="step3SubHeading">
                  Sponsored
                  <img className="step3SponsorImg" src="/assets/icons/sponsor.svg" alt="sponsor-img" />
                </p>
              </div>
            </div>
            {showCircularBar && (
              <div style={{ width: 38, height: 38, fontWeight: "600" }}>
                {data.score && data.score !== -1 && data.score >= 0 && (
                  <CircularProgressbar
                    value={Math.floor(data.score)}
                    text={Math.floor(data.score)}
                    strokeWidth={9}
                    styles={buildStyles({ textSize: "2.5rem", textColor: "black" })}
                  />
                )}
              </div>
            )}
            {showPreviewRibbon && <img className="previewRibbonImg" src={PreviewRibbonImage} alt="previewRibbon-img" />}
          </div>
          <p className="step3Content">{data.headline}</p>
          <div className="step3Img1Div">
            {!data.custom_image && children}
            {data.custom_image && <img className="step3Img1" src={data.custom_image} alt="step3-img1" />}
          </div>
          <div className="step3Card-contactus">
            <p className="step3Card-contactus-para">{data.caption}</p>
            <div className="step3-contactus-link">{data.cta}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default Step3Card;
